export const name = 'gzMonthSelector';
export default function gzMonthSelector(
  // Directive angular dependencies
) {
  'ngInject';

  let directive = {
    restrict: 'EA',
    scope: {
      dateChanged: '=',
      initialDate: '=',
    },
    template: require('./month-selector.jade'),
    link: monthSelectorLink,
    controller: monthSelectorController,
    controllerAs: 'vm',
    bindToController: true,
  };
  return directive;

  //////////////////////

  function monthSelectorLink(scope, element, attrs) {
  }

  /** @ngInject */
  function monthSelectorController(
    // Controller angular dependencies
    moment,
    rnOrganization,
    $mdDialog
  ) {
    // Constants

    // Variables

    // View Model
    let vm = this;

    //   VM properties
    vm.dateRanges = [];
    vm.isLoading = true;
    vm.currentRangeIndex = 0;

    //   VM methods
    vm.getCurrentDateRange = getCurrentDateRange;
    vm.isEarliestDateRange = isEarliestDateRange;
    vm.changeDates = changeDates;
    vm.previousDateRange = previousDateRange;
    vm.nextDateRange = nextDateRange;

    vm.$onInit = onInit;
    return;

    ///////////////
    // Init
    function onInit() {
      rnOrganization.getOrganization().then(org => {
        let fullCreatedDate = moment(org.data.createdTime);
        // We want only month and year so we can more easily compare
        vm.created = moment([fullCreatedDate.year(), fullCreatedDate.month()]);

        initDateRanges(vm.initialDate);
      })
        .finally(() => {
          vm.isLoading = false;
        });
    }

    ///////////////
    // VM methods

    function getCurrentDateRange() {
      if (!_.isEmpty(vm.dateRanges)) {
        let date = vm.dateRanges[vm.currentRangeIndex][0];
        return date;
      }
    }

    function isEarliestDateRange() {
      let cur = getCurrentDateRange();
      if (cur) {
        return cur.year() === vm.created.year() && cur.month() === vm.created.month();
      }
    }

    function changeDates($event) {
      $event.stopPropagation();

      return $mdDialog.show({
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose: false,
        escapeToClose: true,
        template: require('./change_dates.jade'),
        controller: 'gzMonthSelectorChangeDatesController',
        bindToController: true,
        controllerAs: 'vm',
        locals: {
          created: vm.created,
          dateRanges : vm.dateRanges
        }
      })
        .then(newDate => {
          let lastDate = vm.dateRanges[vm.dateRanges.length - 1][0];

          while(newDate.isBefore(lastDate)) {
            let lastRangeBegin = vm.dateRanges[vm.dateRanges.length - 1][0];
            addDateRanges(lastRangeBegin.clone().subtract(1, 'month'));
            lastDate = vm.dateRanges[vm.dateRanges.length - 1][0];
          }

          for (let i = 0; i < vm.dateRanges.length; i++) {
            if (vm.dateRanges[i][0].year() === newDate.year() && vm.dateRanges[i][0].month() === newDate.month()) {
              vm.currentRangeIndex = i;
              break;
            }
          }

          notifyParent();
        });
    }

    function previousDateRange() {
      if (getCurrentDateRange().isBefore(vm.created)) {
        return;
      }

      if( vm.currentRangeIndex >= (vm.dateRanges.length - 1) ) {
        let lastRangeBegin = vm.dateRanges[vm.dateRanges.length - 1][0];
        addDateRanges(lastRangeBegin.clone().subtract(1, 'month'));
      }
      vm.currentRangeIndex++;

      notifyParent();
    }

    function nextDateRange() {
      if (vm.currentRangeIndex === 0) {
        let lastRangeBegin = vm.dateRanges[0][0];
        addDateRanges(lastRangeBegin.clone().add(1, 'month'), false);
      }

      if (vm.currentRangeIndex > 0) {
        vm.currentRangeIndex--;
      }

      notifyParent();
    }

    function notifyParent() {
      vm.dateChanged(vm.getCurrentDateRange());
    }

    ///////////////
    // Helpers

    function initDateRanges(initialDate) {
      let endOfToday = moment(initialDate).endOf('day');
      addDateRanges(endOfToday);
    }

    function addDateRanges(rangeBegin, goBackwards = true) {
      for (let i = 0; i < 12; i++) {

        if (rangeBegin < vm.created) {
          return;
        }

        let nextRangeEnd = rangeBegin.clone().endOf('month');
        let nextRangeBegin = moment([rangeBegin.year(), rangeBegin.month()]);

        if (goBackwards) {
          vm.dateRanges.push([nextRangeBegin, nextRangeEnd]);
          rangeBegin = nextRangeBegin.clone().subtract(1, 'month');
        }
        else {
          vm.dateRanges.splice(0, 0, [nextRangeBegin, nextRangeEnd]);
          rangeBegin = nextRangeBegin.clone().add(1, 'month');
          vm.currentRangeIndex++;
        }
      }
    }
  }
}
